import React from "react";
import { Spring, config } from "react-spring/renderprops";
import Konva from "konva";
import { Arc, Stage, Line, Layer, Text, Rect, Shape } from "react-konva";
import ReactResizeDetector from "react-resize-detector";
import ResizeableStage from "charts/ResizeableStage";
import MetricFormatter from "dashboards/MetricFormatter";
import ReactDOMServer from "react-dom/server";
import jsDig from "utils/jsDig";
import { startCase, camelCase, capitalize } from "lodash";
import GetFormatter from "dashboards/GetFormatter";

function changeColor(color1, color2, percentage) {
  var hex = function (x) {
    x = x.toString(16);
    return x.length == 1 ? "0" + x : x;
  };

  var r = Math.ceil(parseInt(color1.substring(0, 2), 16) * percentage + parseInt(color2.substring(0, 2), 16) * (1 - percentage));
  var g = Math.ceil(parseInt(color1.substring(2, 4), 16) * percentage + parseInt(color2.substring(2, 4), 16) * (1 - percentage));
  var b = Math.ceil(parseInt(color1.substring(4, 6), 16) * percentage + parseInt(color2.substring(4, 6), 16) * (1 - percentage));

  return hex(r) + hex(g) + hex(b);
}

class ChartBar extends React.Component {
  constructor(props) {
    super(props);

    this.textSizeScalar = 0.15;
    this.strokeScalar = 0.08;
    // The graph actually shows only spend except on hover
    this.bars = jsDig(["spend"], this.props.data) ? Object.keys(jsDig(["spend"], this.props.data)) : [];
    if (this.props.order) {
      this.bars = this.props.order;
    }
    this.total = 0;
    this.highestValue = 0;
    this.bars.forEach((bar) => {
      this.total += jsDig(["spend", bar], this.props.data);
      if (jsDig(["spend", bar], this.props.data) > this.highestValue) {
        this.highestValue = jsDig(["spend", bar], this.props.data);
      }
    });

    if (this.total === 0) this.total = 1;

    this.barPercentages = {};

    this.bars.forEach((bar) => {
      this.barPercentages[bar] = ReactDOMServer.renderToString(<MetricFormatter.YY0 value={(jsDig(["spend", bar], this.props.data) * 100) / this.total} />);
    });

    this.state = {
      tooltipText: "",
    };
  }

  componentDidMount() {
    const tooltipElement = $("#" + this.props.id).get(0);
    if (tooltipElement) {
      tooltipElement.setAttribute("data-toggle", "tooltip");
      tooltipElement.setAttribute("data-trigger", "manual");
      tooltipElement.setAttribute("data-placement", "auto");
      tooltipElement.setAttribute("data-html", "true");
      tooltipElement.setAttribute("data-original-title", "");
      tooltipElement.setAttribute("data-custom-class", "geoMapTooltip");
      tooltipElement.setAttribute(
        "data-template",
        '<div class="tooltip geoMapTooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.data = this.props.data;
      this.textSizeScalar = 0.15;
      this.strokeScalar = 0.08;
      // The graph actually shows only spend except on hover
      this.bars = jsDig(["spend"], this.props.data) ? Object.keys(jsDig(["spend"], this.props.data)) : [];
      if (this.props.order) {
        this.bars = this.props.order;
      }
      this.total = 0;
      this.highestValue = 0;
      this.bars.forEach((bar) => {
        this.total += jsDig(["spend", bar], this.props.data);
        if (jsDig(["spend", bar], this.props.data) > this.highestValue) {
          this.highestValue = jsDig(["spend", bar], this.props.data);
        }
      });

      if (this.total === 0) this.total = 1;

      this.barPercentages = {};

      this.bars.forEach((bar) => {
        this.barPercentages[bar] = ReactDOMServer.renderToString(<MetricFormatter.YY0 value={(jsDig(["spend", bar], this.props.data) * 100) / this.total} />);
      });
      // do not understand why I need the below line but we must have it
      this.setState({ tooltipText: "" });
    }
  }
  render() {
    return (
      <div className="p-1" id={this.props.id}>
        <ResizeableStage
          maxHeight={400}
          pdfDim={this.props.pdfDim}
          render={(width, height) => {
            const wOrH = height > width ? width : height;
            const strokeWidth = this.strokeScalar * wOrH;
            const radius = wOrH / 2.1 - strokeWidth / 1.8;

            const hW = width / 2;
            const hH = height / 2;
            const axisLineWidth = height / 65;
            const xAxis = height * 0.9;
            const barPadding = width / 4 / this.bars.length;
            const barWidth = width / this.bars.length - barPadding;
            const interpolateBetweenBeginColor = "42BA96";
            return (
              <>
                <Line stroke="white" strokeWidth={axisLineWidth} points={[0, xAxis + axisLineWidth * 0.5, width, xAxis + axisLineWidth * 0.5]} />
                {this.bars.map((bar, i) => {
                  const spendSegment = jsDig(["spend", bar], this.props.data);
                  return (
                    <React.Fragment key={bar}>
                      <Line
                        stroke="white"
                        strokeWidth={axisLineWidth}
                        points={[
                          i * barWidth + i * barPadding + barPadding / 2 + barWidth / 2,
                          xAxis + axisLineWidth * 0.5,
                          i * barWidth + i * barPadding + barPadding / 2 + barWidth / 2,
                          xAxis + axisLineWidth * 3,
                        ]}
                      />
                      <Text
                        text={bar.charAt(0).toUpperCase() + bar.slice(1)}
                        fill="#212348"
                        fontFamily="nunito-regular"
                        fontSize={height * 0.035}
                        align="center"
                        verticalAlign="middle"
                        x={i * barWidth + i * barPadding + barPadding / 2}
                        width={barWidth * 2}
                        offsetX={barWidth / 2}
                        y={xAxis + axisLineWidth * 4}
                      />
                      <Rect
                        key={bar}
                        width={barWidth}
                        height={(spendSegment / this.highestValue) * (xAxis * 0.8)}
                        y={xAxis - (spendSegment / this.highestValue) * xAxis * 0.8}
                        x={i * barWidth + i * barPadding + barPadding / 2}
                        fill={"#" + changeColor("42BA96", "3291C1", spendSegment / this.highestValue)}
                        onMouseEnter={() => {
                          const barTitle = _.capitalize(bar);
                          let newText = `${barTitle}<br>`;
                          this.props.metricsEnabled.forEach((metricKey, index) => {
                            let Formatter = GetFormatter({ metricName: metricKey });
                            const metricTitle = _.startCase(_.camelCase(metricKey));
                            const metricValue = ReactDOMServer.renderToString(<Formatter value={jsDig([metricKey, bar], this.props.data)} baseCurrency={this.props.baseCurrency} displayCurrency={this.props.displayCurrency} />);
                            newText += `${metricTitle}: ${metricValue}${index < this.props.metricsEnabled.length ? "<br>" : ""}`;
                          });
                          this.setState({ tooltipText: newText });
                          const tooltipElement = $("#" + this.props.id).get(0);
                          tooltipElement.setAttribute("data-original-title", this.state.tooltipText);
                          $("#" + this.props.id).tooltip("show");
                        }}
                        onMouseLeave={() => {
                          $("#" + this.props.id).tooltip("hide");
                        }}
                      />

                      <Text
                        text={this.barPercentages[bar]}
                        fill="#212348"
                        fontFamily="nunito-regular"
                        fontSize={height * 0.035}
                        align="center"
                        verticalAlign="middle"
                        x={i * barWidth + i * barPadding + barPadding / 2}
                        width={barWidth}
                        y={xAxis - (spendSegment / this.highestValue) * xAxis * 0.8 - xAxis * 0.05}
                      />
                    </React.Fragment>
                  );
                })}
              </>
            );
          }}></ResizeableStage>
      </div>
    );
  }
}

export default ChartBar;
